import React from 'react';
import cn from 'classnames';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

interface Props {
  className?: string;
  data: Array<any>;
  label: string;
  disabled: boolean;
  id: string;
  value: string | undefined;
  onChange: (e: any, newValue: string | undefined) => void;
}

const InputLayout: React.FC<Props> = React.memo(
  ({ className, disabled, data, label, id, value, onChange }) => {
    return (
      <div className={cn(className)}>
        <Autocomplete
          id={id}
          value={value}
          onChange={onChange}
          disabled={disabled}
          options={data}
          renderInput={(params) => (
            <TextField {...params} size="small" label={label} margin="normal" />
          )}
        />
      </div>
    );
  },
);

export default InputLayout;
